// extracted by mini-css-extract-plugin
module.exports = {"darkLightBtn":"dark-light-button-module--dark-light-btn--m-KP6"};